const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallbit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.81 28.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.43,0L0,7.08v4.52l12.33-7.13,2.65,1.44-8.79,4.61,4.3,2.38,8.22-4.7V3.59L12.43,0Z",
    style: {
      fill: "#0d99ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.81,21.15V6.99l-3.97-2.24-.05,14.11-2.46,1.49.33-9.78-4.21,2.47v9.41l4.06,2.28,6.29-3.59Z",
    style: {
      fill: "#0d99ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21.15l12.43,7.08,3.97-2.28-12.38-7.13-.09-2.84,8.41,5.22-.05-4.84-8.22-4.7L0,13.97v7.17Z",
    style: {
      fill: "#0d99ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallbit);
export default __webpack_public_path__ + "static/media/wallbit.9cd45971a933280446f8c8daa42876f9.svg";
export { ForwardRef as ReactComponent };